// Core & Styles
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import AuthLayout from "./auth/Layout";

import Login from "./auth/Login";
import Register from "./auth/Register";
// Dashboard
import Search from "./pages/search/index";
import SearchPet from "./pages/search/Search";
import SearchPage from "./pages/search/SearchPage";
import QRScanPage from "./pages/search/QRScanPage";

// History
import ServiceVaccine from "./pages/service/service_vaccine";
import ServiceMicrochip from "./pages/service/service_microchip";
import Home from "./pages/Home";


const router = createBrowserRouter([
  {
    Component: App,
    children: [
      {
        path: "/",
        children: [
          {
            path: "",
            Component: Home,
            children: [
              {
                path: "home",
                Component: Home,
              },
            ],
          },
          {
            path: "home",
            Component: Home,
            children: [
              {
                path: "",
                Component: Home,
              },
            ],
          },
          {
            path: "/service",
            children: [
              {
                path: "vaccine/:id",
                Component: ServiceVaccine,
              },
              {
                path: "microchip/:id",
                Component: ServiceMicrochip,
              },
            ],
          },
          // {
          //   path: "/users",
          //   Component: Users,
          //   children: [
          //     {
          //       path: "",
          //       Component: ListUsers,
          //     },
          //   ],
          // },
          // {
          //   path: "/pets",
          //   Component: Pet,
          //   children: [
          //     {
          //       path: "",
          //       Component: PetList,
          //     },
          //     {
          //       path: ":id",
          //       Component: PetDetail,
          //     },
          //   ],
          // },
          {
            path: "/search",
            Component: Search,
            children: [
              {
                path: "pet",
                Component:SearchPet ,
              },
              {
                path: "qr",
                Component: QRScanPage,
              },
              {
                path: "word",
                Component: SearchPage,
              },
            ],
          },

        ],
      },
    ],
  },
  {
    path: "/auth",
    Component: AuthLayout,
    children: [
      {
        path: "login",
        Component: Login,
      },
      {
        path: "register",
        Component: Register,
      },
    ],
  },

]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <RouterProvider router={router} />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
